import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('radio');

export { TAG_NAME };
